<template>
  <div>
    <ts-loading-banner :loading="waiting">
      <div class="ts-flex">
        <div class="ts-relative ts-w-full">
          <input
            v-model.trim="search"
            ref="search"
            type="text"
            class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
            :placeholder="$t('stockTransfer.searchProduct')"
            @keypress.enter="productLists"
          />
          <span
            class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
            style="margin-top: 7px"
            ><i class="fa fa-search"></i
          ></span>
        </div>
      </div>
      <br />
      <div class="max-h ts-px-3">
        <table class="ts-w-full">
          <tr
            class="ts-border-b ts-border-gray-400"
            v-for="product in productResources"
            :key="product.product_id"
          >
            <td class="ts-text-xs ts-whitespace-no-wrap">
              {{ product.barcode }}
            </td>
            <td class="ts-text-xs ts-whitespace-no-wrap">
              {{ product.group ? product.group.pro_group_name_en : '' }}
            </td>
            <td class="ts-text-xs ts-whitespace-no-wrap">
              {{ product.product_name_en }}
            </td>
            <td class="ts-text-right ts-whitespace-no-wrap">
              <input
                v-model.number="product.quantity"
                type="number"
                placeholder="Qty"
                class="ts-w-16 ts-outline-none ts-border-b ts-px-2 ts-rounded ts-mb-1 ts-text-xs"
                @keypress.enter="addProduct(product)"
              />
            </td>
            <td style="width:1%" class="text-center ts-pl-4">
              <a
                href="#"
                v-tooltip="$t('add')"
                @click.prevent="addProduct(product)"
                class="ts-mb-0"
              >
                <i class="fa fa-plus"></i>
              </a>
            </td>
          </tr>
        </table>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'manualAdd',
  props: ['value'],
  data () {
    return {
      waiting: false,
      productResources: [],
      search: '',
      model: {}
    }
  },
  mounted () {
    this.$refs.search.focus()
  },
  created () {
    this.model = this.value
    this.productLists()
  },
  computed: {
    ...mapGetters('stock/writeOff', ['isDefaultUom']),
    ...mapState('stock/writeOff', ['products', 'productAvailable'])
  },
  methods: {
    ...mapActions('stock/writeOff', ['availableQuantity']),
    productLists () {
      this.productResources = []
      if (this.search) {
        this.productResources = _.orderBy(this.products, ['barcode'], ['asc'])
          .filter(
            s =>
              s.is_generate_unique_serial == false &&
              !_.includes(
                this.model.sub_item_list.map(t => t.product_id),
                s.product_id
              )
          )
          .filter(
            s =>
              s.barcode
                .toLowerCase()
                .includes(this.search.trim().toLowerCase()) ||
              s.product_name_en
                .toLowerCase()
                .includes(this.search.trim().toLowerCase()) ||
              (s.group
                ? s.group.pro_group_name_en
                    .toLowerCase()
                    .includes(this.search.trim().toLowerCase())
                : '')
          )
          .filter(s => s.is_generate_unique_serial == false)
          .splice(0, 500)
        return
      }
      this.productResources = _.orderBy(this.products, ['barcode'], ['asc'])
        .filter(
          s =>
            s.is_generate_unique_serial == false &&
            !_.includes(
              this.model.sub_item_list.map(t => t.product_id),
              s.product_id
            )
        )
        .splice(0, 50)
    },
    async addProduct (product) {
      this.waiting = true
      await this.availableQuantity(product.product_id)
        .then(response => {
          var uom_id = this.isDefaultUom(product.product_id)
          this.model.sub_item_list.unshift({
            product_id: product.product_id,
            uom_id: uom_id,
            quantity: product.quantity ? product.quantity : 1,
            available_quantity: response.data.ending_balance,
            cost: 0,
            serial_no: []
          })
          this.productLists()
          this.$nextTick(() => {
            this.$refs.search.focus()
            this.$refs.search.select()
          })
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>

<style scoped>
.max-h {
  height: 400px;
  max-height: 500px;
  overflow: scroll;
}
</style>
